import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  CompletedPollAnswer,
  CompletedTriviaAnswer,
  GroupType,
  IAnswer,
  ProcessedPredictorAnswer,
  GamesGroupService,
} from '@fgb/core';
import { firstValueFrom, tap } from 'rxjs';

@Component({
  selector: 'fgbcl-answer-type-text-and-image',
  templateUrl: './answer-type-text-and-image.component.html',
  styleUrl: './answer-type-text-and-image.component.scss',
})
export class AnswerTypeTextAndImageComponent implements OnInit {
  selectedAnswer: any;
  correctAnswerId: number;
  selectedAnswerIsCorrect: boolean;
  loading: boolean = false;
  groupTypes = GroupType;
  completed: boolean = false;
  @Input() answers: IAnswer[] | undefined;
  @Input() questionId: number;
  @Input() groupId: number;
  @Input() groupType: GroupType;
  @Output() answerSelected = new EventEmitter<any>();
  @Output() loadingState = new EventEmitter<boolean>();
  @Input() isExternal: boolean = false;
  constructor(private gamesGroupService: GamesGroupService) {}

  ngOnInit(): void {
    this.selectedAnswer = this.answers
      ?.map((answer) => answer as ProcessedPredictorAnswer | CompletedTriviaAnswer | CompletedPollAnswer)
      .find((answer) => answer.UserSelected);
  }

  onAnswerSelected(answer: any) {
    if (this.groupType == GroupType.Trivia) {
      this.submitTriviaAnswer(answer);
    } else {
      this.selectedAnswer = answer;
      this.answerSelected.emit(answer);
    }
  }

  submitTriviaAnswer(answer: any) {
    if (this.completed) {
      return;
    }
    this.loading = true;
    this.loadingState.emit(this.loading);
    this.selectedAnswer = answer;
    firstValueFrom(
      this.gamesGroupService.submitTriviaAnswer(this.questionId, this.selectedAnswer.Id, this.groupId, this.isExternal).pipe(
        tap((result) => {
          this.correctAnswerId = result.CorrectAnswerId;
          this.selectedAnswerIsCorrect = this.correctAnswerId == this.selectedAnswer.Id;
        })
      )
    ).then(() => {
      firstValueFrom(this.gamesGroupService.fetchTriviaGroupGames(this.groupId, this.isExternal)).then((gameDetails) => {
        setTimeout(() => {
          this.answers = gameDetails.Questions.find((question) => question.Id == this.questionId)?.Answers;
          this.loading = false;
          this.completed = true;
          this.answerSelected.emit(gameDetails);
          this.loadingState.emit(this.loading);
        }, 300);
      });
    });
  }
}
